import { Avatar, Dropdown, Menu, Tag, Tooltip } from 'antd'
import styles from './style.module.scss'
import { AppstoreFilled, TagsOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { useData } from '../../../../../contexts/data-context'
import { HC_MANAGER_URL } from '../../../../../constants/Config'
import {isCollectAnalytics, isIframe, trackEvent} from "../../../../../services/utils";

const AppsMenu = () => {
  const [appsPopup, setAppsPopup] = useState(false)
  const [appsTooltip, setAppsTooltip] = useState(false)
  const { product, resolveloop_enabled } = useData()

  const iconMap = {
    classify: <TagsOutlined className="mr-2" />,
  }

  const listed_products = [
    {
      name: 'mergedup',
      label: 'Auto Merge Duplicate Tickets',
      icon: 'git-merge',
    },
    {
      name: 'redact',
      label: 'Auto Remove Attachments',
      icon: 'x-square',
    },
    {
      name: 'triggers_gpt',
      label: 'Triggers+ChatGPT',
      icon: 'aperture',
    },
    {
      name: 'classify',
      label: <span>Ticket Classification <Tag color="yellow">new</Tag></span>,
      icon: 'tags',
    },
    {
      name: 'lookup',
      label: 'Ticket Parser Autofill',
      icon: 'hash',
    },
    {
      name: 'document_parser',
      label: <span>Document Parser OCR <Tag color="yellow">new</Tag></span>,
      icon: 'file-text',
    },
    {
      name: 'cowriter',
      label: 'Agent Co-writer',
      icon: 'send',
    },
    {
      name: 'translate',
      label: 'Translate Conversations',
      icon: 'message-square',
    },
    {
      name: 'exportPdfs',
      label: 'Articles PDF Export',
      icon: 'file-text',
    },
    {
      name: 'easydoc',
      label: 'Help Center Export',
      icon: 'download',
    },
    {
      name: 'macroexport',
      label: 'Macros Export',
      icon: 'archive',
    },
    {
      name: 'mcpserver',
      label: 'Zendesk MCP Server',
      icon: 'server',
    },
    {
      name: 'resolveloop',
      label: 'ResolveLoop',
      icon: 'repeat',
    },
    {
      name: 'hcmanager',
      label: 'Help Center Manager',
      icon: 'edit',
    },
    {
      name: 'hcanalytics',
      label: 'Help Center Analytics',
      icon: 'bar-chart-2',
    },
    {
      name: 'hctranslate',
      label: 'Help Center Translate',
      icon: 'globe',
    },
  ]

  useEffect(() => {
    const close_apps_tooltip = localStorage.getItem('close_apps_tooltip')
    if (close_apps_tooltip !== 'true') {
      setTimeout(() => {
        setAppsTooltip(true)
      }, 2000)
    }
  }, [])

  const openApp = (current_product, new_product) => {
    if (isCollectAnalytics(new_product)) {
      trackEvent('Menu_OpenApp', {product: current_product, new_product: new_product, iframe: isIframe()})
    }
    if (current_product === new_product) return
    localStorage.setItem('close_apps_tooltip', 'true')
    if (['hcmanager', 'hcanalytics', 'hctranslate'].indexOf(new_product) >= 0) {
      const url = `${HC_MANAGER_URL}${
        new_product === 'hcanalytics' ? '/analytics' : ''
      }?product=${new_product}`
      window.open(url, '_blank')
    } else {
      localStorage.setItem('current_product', new_product)
      window.history.replaceState({}, '', '/?product=' + new_product)
      window.location.reload()
    }
  }

  const menu = (
    <Menu selectable={false}>
      <Menu.Item key={0}>
        <strong>Swifteq Zendesk Apps</strong>
      </Menu.Item>
      <Menu.Divider />
      {listed_products.filter((p) => p.name !== 'resolveloop' || resolveloop_enabled).map((p, i) => {
        return (
          <Menu.Item key={i + 1} style={{ background: p.name === product ? '#f5f5f5' : null }}>
            <a onClick={() => openApp(product, p.name)}>
              {iconMap[p.name] || <i className={`fe fe-${p.icon} mr-2`} />}
              {p.label}
            </a>
          </Menu.Item>
        )
      })}
    </Menu>
  )
  return (
    <Tooltip
      placement="bottomRight"
      trigger={'focus'}
      open={appsTooltip}
      visible={appsTooltip}
      title={
        <div style={{ padding: '10px' }}>
          <div className="mb-2">
            <i className="fe fe-award mr-1 font-weight-bold" /> Explore our range of Zendesk apps
            designed to make your customer support seamless and effective.
          </div>
          <div>
            <a
              onClick={() => {
                setAppsTooltip(false)
                setAppsPopup(true)
              }}
              className="text-warning"
            >
              show apps
            </a>
            <a onClick={() => setAppsTooltip(false)} className="text-warning ml-3">
              close
            </a>
          </div>
        </div>
      }
    >
      <Dropdown
        overlay={menu}
        trigger={['click']}
        className="mr-2"
        open={appsPopup}
        visible={appsPopup}
        onVisibleChange={() => setAppsTooltip(false)}
        onOpenChange={() => setAppsTooltip(false)}
      >
        <div
          className={styles.dropdown}
          onClick={() => {
            // localStorage.setItem('close_apps_tooltip', 'true')
            setAppsPopup(!appsPopup)
          }}
        >
          <Avatar className={styles.avatar} shape="square" size="large" icon={<AppstoreFilled />} />
        </div>
      </Dropdown>
    </Tooltip>
  )
}

export default AppsMenu
